// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-enter-active[data-v-43a19585],.list-leave-active[data-v-43a19585]{transition:all 1s}.list-enter[data-v-43a19585],.list-leave-to[data-v-43a19585]{opacity:0}.p-mypage__order--preorder[data-v-43a19585]{color:#f06292}", ""]);
// Exports
module.exports = exports;
